import _ from 'lodash'

function buildPayload(isAdmin, values, isDeleteSession, userEmail) {
  const password = _.get(values, ['password'])
  const confirmPassword = _.get(values, ['confirmPassword'])
  const currentPassword = _.get(values, ['currentPassword'])
  let optionParamObj = {}

  if (isAdmin) {
    optionParamObj = {
      email: userEmail
    }
  }
  const requestObj = {
    password,
    confirm_password: confirmPassword,
    current_password: currentPassword,
    ...optionParamObj
  }

  if (isDeleteSession) {
    return { ...requestObj, delete_old_sessions: true }
  }

  return requestObj
}

export default { buildPayload }
